module.exports = __webpack_public_path__ + "static/media/videos-4@2x.859e84d9.jpg";